import { createContext } from "react";

const FiltersContext = createContext<any>({});

export default FiltersContext;
